<button (click)="buttonClick()" mat-raised-button [color]="color">
    <ng-container *ngIf="icon">
        <mat-icon>{{icon}}</mat-icon>
    </ng-container>
    <ng-container *ngIf="text">
        {{text}}
    </ng-container>
    <ng-content></ng-content>
</button>
